export function normalizeLearningJourneyEntityId(id: string): string {
  return id.startsWith("client:") ? id.slice("client:".length) : id;
}

export function resolveLearningJourneyEntityId<T extends string>(
  availableIds: Iterable<T>,
  requestedId: string,
): T | undefined {
  const ids = Array.from(availableIds);

  const exactMatch = ids.find((id) => id === requestedId);
  if (exactMatch) {
    return exactMatch;
  }

  const normalizedRequestedId = normalizeLearningJourneyEntityId(requestedId);
  return ids.find(
    (id) => normalizeLearningJourneyEntityId(id) === normalizedRequestedId,
  );
}

export function requireLearningJourneyEntityId<T extends string>(
  availableIds: Iterable<T>,
  requestedId: string,
  entityType: "chapter" | "lesson",
): T {
  const resolvedId = resolveLearningJourneyEntityId(availableIds, requestedId);
  if (!resolvedId) {
    throw new Error(`Unable to find ${entityType} ${requestedId}`);
  }

  return resolvedId;
}

export function getLearningJourneyEntityNameById(
  namesById: ReadonlyMap<string, string>,
  requestedId: string,
): string | undefined {
  const resolvedId = resolveLearningJourneyEntityId(
    namesById.keys(),
    requestedId,
  );

  return resolvedId ? namesById.get(resolvedId) : undefined;
}
